// TODO: expose all this functionality to both backend and frontend as a lib instead of copy-paste

export const noop = () => undefined;
export const alwaysTruePredicate = () => true;
export const alwaysFalsePredicate = () => false;
/**
 * Returns a predicate that checks for (in)equality to id(s) in the provided item.
 * @param ids {string || Array<string>} id(s) to check for.
 * @param reverse {Boolean} If true, checks for inequality to id(s). If false, checks for equality.
 * @returns {(function(*): boolean)} The resulting predicate.
 */
export const itemIdPredicateFactory = (ids, reverse = false) => {
    const compare = reverse
        ? (lhs, rhs) => (lhs !== rhs)
        : (lhs, rhs) => (lhs === rhs);

    if (Array.isArray(ids)) {
        return reverse
            // Not equal to any of the ids. I know, it's hard to grasp from first glance.
            ? (item) => ids.every((id) => compare(item.id, id))
            : (item) => ids.some((id) => compare(item.id, id));
    }

    return (item) => compare(item.id, ids);
};



// WEBPACK FOOTER //
// ./src/components/helpers/funcTools.js